/**
 * useDevice — hook de détection plateforme
 *
 * Retourne :
 *   isNative   → true si Capacitor iOS/Android
 *   isMobile   → true si natif OU navigateur mobile OU écran ≤ 768px
 *   isDesktop  → !isMobile
 *   platform   → 'ios' | 'android' | 'web'
 *   isIOS      → true sur iPhone/iPad
 *   isAndroid  → true sur Android
 *   safeAreaTop    → px de safe-area en haut (notch)
 *   safeAreaBottom → px de safe-area en bas (home indicator)
 */
import { useState, useEffect } from 'react';
import { IS_NATIVE, IS_MOBILE, IS_IOS, IS_ANDROID, PLATFORM } from '../lib/capacitorShim';

export function useDevice() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const isMobile  = IS_NATIVE || IS_MOBILE || width <= 768;
  const isDesktop = !isMobile;

  // Safe area (notch iPhone, barre Android) via CSS env()
  const safeAreaTop    = getCSSEnv('--sai-top',    IS_IOS ? 44 : 24);
  const safeAreaBottom = getCSSEnv('--sai-bottom', IS_IOS ? 34 : 0);

  return {
    isNative: IS_NATIVE,
    isMobile,
    isDesktop,
    platform: PLATFORM.platform,
    isIOS: IS_IOS,
    isAndroid: IS_ANDROID,
    safeAreaTop,
    safeAreaBottom,
    screenWidth: width,
  };
}

function getCSSEnv(varName, fallback) {
  try {
    const val = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(varName),
      10
    );
    return isNaN(val) ? fallback : val;
  } catch {
    return fallback;
  }
}
